module.exports = __webpack_public_path__ + "static/media/progenitor_division.414e46f0.gif";